import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { SendMail } from "../../lib/api";
import AnimatedElement from "../../components/content/textAnimation/page";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/ui/loader";

function Partnership() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const mutateSendMail = useMutation({
    onMutate: () => {
      setIsSubmitting(true);
    },
    mutationFn: (data) => {
      const response = SendMail(data);
      return response;
    },
    onSuccess: () => {
      toast.success("Successfully send mail");
    },
    onError: () => {
      toast.error("Send Mail Failed!");
    },
    onSettled: () => {
      reset();
      setIsSubmitting(false);
    },
  });

  const onSubmit = (data) => {
    const formData = {
      ...data,
      subject: "Become A Partner",
    };
    mutateSendMail.mutate(formData);
  };
  return (
    <div>
      <div className="flex flex-1 w-full flex-col items-center justify-center text-center px-4 py-10 sm:py-20 bg-gradient-to-r from-green-50/50 via-teal-50 to-green-50/50">
        <h1 className="mx-auto max-w-4xl font-display poppins_bold tracking-normal text-white-300 text-2xl min-[480px]:text-4xl sm:text-5xl md:text-7xl">
          Get ready to earn{" "}
          <span className="relative whitespace-nowrap text-white-600">
            One Lakh{" "}
          </span>
          <span className="relative whitespace-nowrap text-orange-500">
            <svg
              aria-hidden="true"
              viewBox="0 0 418 42"
              className="absolute top-2/3 left-0 h-[0.58em] w-full fill-orange-500 dark:fill-orange-300/60"
              preserveAspectRatio="none"
            >
              <path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.780 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.540-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.810 23.239-7.825 27.934-10.149 28.304-14.005 .417-4.348-3.529-6-16.878-7.066Z"></path>
            </svg>
            <span className="relative">Per Month!</span>
          </span>
        </h1>
        <h2 className="poppins_light min-[480px]:poppins_medium mx-auto mt-6 sm:mt-12 max-w-3xl text-lg sm:text-white-400 text-white-500 leading-7">
          Want to earn 1 lakh a month? Become a MobiPOS dealer and kickstart
          your journey to big earnings with our smart billing solutions. Join us
          today and watch your income grow!
        </h2>
      </div>
      <div id="form">
        <div className="container mx-auto p-4">
          <h2 className="poppins_bold text-2xl min-[480px]:text-3xl sm:text-4xl underline text-center  text-orange-500">
            Become a Partner
          </h2>
          <p className="poppins_medium text-center mt-4">
            Tell us about you and your company.
          </p>
          <form
            className="max-w-3xl mx-auto py-10"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5 poppins_medium">
              <div className="mb-2 w-full">
                <label className="mb-2 text-base">
                  First Name<span className="text-red-600">*</span>
                </label>
                <input
                  {...register("firstName", { required: true })}
                  type="text"
                  placeholder="First Name"
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                  required
                />
              </div>
              <div className="mb-2 w-full">
                <label className="mb-2 text-base">Last Name</label>
                <input
                  {...register("lastName")}
                  type="text"
                  placeholder="Last Name"
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                />
              </div>
              <div className="mb-2 w-full">
                <label className="mb-2 text-base">
                  Email<span className="text-red-600">*</span>
                </label>
                <input
                  {...register("email", { required: true })}
                  type="text"
                  placeholder="Email"
                  required
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                />
              </div>
              <div className="mb-2">
                <label className="mb-2 text-base">
                  Phone Number<span className="text-red-600">*</span>
                </label>
                <input
                  {...register("number", {
                    required: "Phone number is required",
                    pattern: {
                      value: /^[0-9]*$/,
                      message: "Please enter a valid phone number",
                    },
                  })}
                  type="text"
                  required
                  placeholder="Phone Number"
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                />
                {errors.number && (
                  <p className="m-2 text-red-600">{errors.number.message}</p>
                )}
              </div>
              <div className="mb-2">
                <label className="mb-2 text-base">
                  Pincode<span className="text-red-600">*</span>
                </label>
                <input
                  {...register("pincode", {
                    required: "Pincode is required",
                    pattern: {
                      value: /^[0-9]*$/,
                      message: "Please enter a valid pincode",
                    },
                  })}
                  required
                  type="text"
                  placeholder="Pincode"
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                />
                {errors.pincode && (
                  <p className="m-2 text-red-600">{errors.pincode.message}</p>
                )}
              </div>
              <div className="mb-2">
                <label className="mb-2 text-base">
                  How did you hear about us?
                </label>
                <select
                  defaultValue="Online Search"
                  {...register("source", {
                    required: "Please select a valid option",
                    validate: (value) =>
                      value !== "0" || "Please select a valid option",
                  })}
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                >
                  <option value="Online Search">Online Search</option>
                  <option value="Youtube">Youtube</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Friend">Friend</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <hr className="mt-10" />
            <h2 className="mb-8 poppins_bold ">Company Information</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
              <div className="w-full">
                <label className="mb-2 text-base">
                  Company Name<span className="text-red-600">*</span>
                </label>
                <input
                  {...register("companyName", { required: true })}
                  type="text"
                  placeholder="Company Name"
                  required
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                />
                {errors.companyName?.type === "required" && (
                  <p className="m-2 text-red-600" role="alert">
                    Company name is required
                  </p>
                )}
              </div>
              <div className="mb-2 w-full">
                <label className="mb-2 text-base">
                  Company Email<span className="text-red-600">*</span>
                </label>
                <input
                  {...register("companyEmail", { required: true })}
                  type="email"
                  placeholder="Company Email"
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                />
                {errors.companyEmail?.type === "required" && (
                  <p className="m-2 text-red-600" role="alert">
                    Company Email is required
                  </p>
                )}
              </div>
              <div>
                <label className="mb-2 text-base">
                  Type of Business<span className="text-red-600">*</span>
                </label>
                <select
                  defaultValue="Retail"
                  {...register("companyType", {
                    required: "Please select a company type",
                    validate: (value) =>
                      value !== "0" || "Please select a valid option",
                  })}
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                >
                  <option value="Retail">Retail</option>
                  <option value="Wholesale">Wholesale</option>
                  <option value="Distributor">Distributor</option>
                  <option value="Service">Service</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Other">Other</option>
                </select>

                {errors.companyType && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.companyType.message}
                  </p>
                )}
              </div>

              <div>
                <label className="mb-2 text-base">
                  Business Category<span className="text-red-600">*</span>
                </label>
                <select
                  defaultValue="Accounting & CA"
                  {...register("companyCategory", {
                    required: "Please select a company category",
                    validate: (value) =>
                      value !== "0" || "Please select a valid option",
                  })}
                  required
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                >
                  <option value="Accounting & CA">Accounting & CA</option>
                  <option value="Automobiles/ Auto parts">
                    Automobiles/ Auto parts
                  </option>
                  <option value="Book / Stationary store">
                    Book / Stationary store
                  </option>
                  <option value="Chemicals & Fertilizers">
                    Chemicals & Fertilizers
                  </option>
                  <option value="Coaching & Training">
                    Coaching & Training
                  </option>
                  <option value="Computer Equipments & Softwares">
                    Computer Equipments & Softwares
                  </option>
                  <option value="Construction Materials & Equipment">
                    Construction Materials & Equipment
                  </option>
                  <option value="Digital Marketers">Digital Marketers</option>
                  <option value="Electrical & Electronics Equipments">
                    Electrical & Electronics Equipments
                  </option>
                  <option value="Fashion Accessory/ Cosmetics">
                    Fashion Accessory/ Cosmetics
                  </option>
                  <option value="Fitness Center">Fitness Center</option>
                  <option value="FMCG Products">FMCG Products</option>
                  <option value="Fruit And Vegetable">
                    Fruit And Vegetable
                  </option>
                  <option value="Garment/Fashion & Hosiery">
                    Garment/Fashion & Hosiery
                  </option>
                  <option value="Hardware Store">Hardware Store</option>
                  <option value="Industrial Machinery & Equipment">
                    Industrial Machinery & Equipment
                  </option>
                  <option value="Kirana/ General Merchant">
                    Kirana/ General Merchant
                  </option>
                  <option value="Mobile & Accessories">
                    Mobile & Accessories
                  </option>
                  <option value="NGO & Charitable trust">
                    NGO & Charitable trust
                  </option>
                  <option value="Paper & Paper Products">
                    Paper & Paper Products
                  </option>
                  <option value="Pharmacy/ Medical">Pharmacy/ Medical</option>
                  <option value="Renting & Leasing">Renting & Leasing</option>
                  <option value="Repairing/ Plumbing/ Electrician">
                    Repairing/ Plumbing/ Electrician
                  </option>
                  <option value="Restaurant/ Hotel">Restaurant/ Hotel</option>
                  <option value="Software Sellers">Software Sellers</option>
                  <option value="Tax, GST and Financial Consultant">
                    Tax, GST and Financial Consultant
                  </option>
                  <option value="Tours & Travels">Tours & Travels</option>
                  <option value="Other">Other</option>
                </select>
                {errors.companyCategory?.type === "required" && (
                  <p className="m-2 text-red-600" role="alert">
                    Company Category is required
                  </p>
                )}
              </div>
              <div className="w-full col-span-1 sm:col-span-2">
                <label className="mb-2 text-base">
                  Address<span className="text-red-600">*</span>
                </label>
                <textarea
                  {...register("companyAddress", { required: true })}
                  type="text"
                  placeholder="Address"
                  rows={5}
                  required
                  className="w-full poppins_light rounded-md border bg-white py-3 px-6 text-base font-medium outline-none shadow-md"
                />
                {errors.companyAddress?.type === "required" && (
                  <p className="m-2 text-red-600" role="alert">
                    Company Address is required
                  </p>
                )}
              </div>
            </div>
            <div className=" flex items-center justify-center">
              <button
                disabled={isSubmitting}
                className="w-fit px-10 py-2 poppins_medium bg-orange-500 text-white rounded-md mt-6"
              >
                {isSubmitting ? <Spinner /> : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="mx-auto bg-[#F5F7FF] ">
        <div className="flex flex-col md:flex-row mt-5 pt-14 gap-5 px-2 max-w-[1024px] mx-auto ">
          <div className="w-full md:w-1/2 order-2 md:order-1">
            <AnimatedElement animationClass="animate__fadeInLeft" delay={0}>
              <h2 className="poppins_regular text-2xl min-[480px]:text-3xl">
                Why partner with us?
              </h2>
              <p className="poppins_light min-[480px]:poppins_medium py-2 leading-8 mt-5 text-justify">
                MobiPOS is a trusted billing and accounting solution that helps
                businesses manage sales and finances efficiently. With 1,000+
                successful partners across India, we are rapidly expanding and
                looking for passionate individuals to join our network.Our
                partners have already earned significant commissions by offering
                MobiPOS to businesses in need of a smarter billing solution.
                With a growing market and high demand, this is the perfect
                opportunity to boost your income and expand your business.!
              </p>
            </AnimatedElement>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2 m-auto">
            <AnimatedElement animationClass="animate__fadeInRight" delay={0}>
              <img
                src="/images/partnership/01.svg"
                alt="sss"
                className="w-full m-auto "
              />
            </AnimatedElement>
          </div>
        </div>
      </div>

      <div>
        <div className="flex flex-col md:flex-row pt-14 gap-5 px-2 max-w-[1024px] m-auto">
          <div className="w-full md:w-1/2">
            <h2 className="poppins_regular text-2xl min-[480px]:text-3xl">
              Guaranteed <br />
              Annual Income
            </h2>
            <h3 className="poppins_bold text-lg mt-3">
              Stable Earning Potential
            </h3>
            <p className="poppins_light min-[480px]:poppins_medium font-light py-2 mt-3 text-justify md:text-start leading-8">
              By partnering with Xenia Technologies, you can earn a consistent
              income by introducing businesses to our efficient billing
              solutions
            </p>
            <Link
              to={"#form"}
              className="bg-[#F9A21B] poppins_medium hidden md:flex rounded-full w-fit text-white py-2 px-4 items-center gap-2"
            >
              Become a Partner
            </Link>
          </div>
          <div className="w-full md:w-1/2 m-auto">
            <AnimatedElement animationClass="animate__fadeInRight" delay={0}>
              <img
                src="/images/partnership/02.png"
                alt="sss"
                className="w-full"
              />
            </AnimatedElement>
          </div>
          <div className="block md:hidden">
            <Link
              to={"#form"}
              className="bg-[#F9A21B] poppins_medium block md:hidden rounded-full w-fit mx-auto text-white py-2 px-4 items-center gap-2"
            >
              Become a Partner
            </Link>
          </div>
        </div>
        <div className="flex flex-col-reverse md:flex-row pt-14 gap-5 px-2 max-w-[1024px] m-auto">
          <div className="w-full md:w-1/2 m-auto">
            <AnimatedElement animationClass="animate__fadeInLeft" delay={0}>
              <img
                src="/images/partnership/03.png"
                alt="sss"
                className="w-full"
              />
            </AnimatedElement>
            <div className="flex md:hidden justify-center">
              <Link
                to={"#form"}
                className="bg-[#F9A21B] poppins_medium rounded-full w-fit text-white py-2 px-4 mt-4 items-center gap-2"
              >
                Become a Partner
              </Link>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:text-right">
            <h2 className="poppins_regular text-2xl min-[480px]:text-3xl">
              Quick & Easy
              <br />
              Implementation
            </h2>
            <h3 className="poppins_bold text-lg mt-3">Effortless Setup</h3>
            <p className="poppins_light :poppins_medium font-light py-2 mt-3 text-justify md:text-end leading-8">
              Our software is designed for fast setup, allowing businesses to
              start using it without delays or complications.
            </p>
            <Link
              to={"#form"}
              className="bg-[#F9A21B] poppins_medium hidden md:flex ml-auto rounded-full w-fit text-white py-2 px-4 items-center gap-2"
            >
              Become a Partner
            </Link>
          </div>
        </div>
        <div className="flex flex-col md:flex-row pt-8 sm:pt-14 gap-5 px-2 max-w-[1024px] m-auto ">
          <div className="w-full md:w-1/2 mt-10">
            <h2 className="poppins_regular text-2xl min-[480px]:text-3xl">
              Multi-Industry <br />
              Usability
            </h2>
            <h3 className="poppins_bold text-lg mt-3">
              Serve Various Industries
            </h3>
            <p className="poppins_light min-[480px]:poppins_medium font-light py-2 mt-3 text-justify md:text-start leading-8">
              With one versatile solution, you can cater to restaurants, retail,
              salons, van sales, and more, broadening your reach.
            </p>
            <Link
              to={"#form"}
              className="bg-[#F9A21B] poppins_medium hidden md:flex rounded-full w-fit text-white py-2 px-4 items-center gap-2"
            >
              Become a Partner
            </Link>
          </div>
          <div className="w-full md:w-1/2 m-auto">
            <AnimatedElement animationClass="animate__fadeInRight" delay={0}>
              <img
                src="/images/partnership/04.png"
                alt="sss"
                className="w-full"
              />
            </AnimatedElement>
            <div className="flex md:hidden justify-center py-4">
              <Link
                to={"#form"}
                className="bg-[#F9A21B] poppins_medium flex md:hidden justify-center rounded-full w-fit text-white py-2 px-4 items-center gap-2"
              >
                Become a Partner
              </Link>
            </div>
          </div>
        </div>
        <div className="flex flex-col-reverse md:flex-row py-8 sm:py-14 gap-5 px-2 max-w-[1024px] m-auto">
          <div className="w-full md:w-1/2 m-auto">
            <AnimatedElement animationClass="animate__fadeInLeft" delay={0}>
              <img
                src="/images/partnership/05.png"
                alt="sss"
                className="w-full"
              />
            </AnimatedElement>
            <div className="flex md:hidden justify-center py-4">
              <Link
                to={"#form"}
                className="bg-[#F9A21B] poppins_medium flex md:hidden justify-center rounded-full w-fit text-white py-2 px-4 items-center gap-2"
              >
                Become a Partner
              </Link>
            </div>
          </div>
          <div className="w-full md:w-1/2 mt-10 md:text-right">
            <h2 className="poppins_regular text-2xl min-[480px]:text-3xl">
              Simple Installation <br />& Training
            </h2>
            <h3 className="poppins_bold text-lg mt-3">Quick Start</h3>
            <p className="poppins_light min-[480px]:poppins_medium font-light py-2 mt-3 text-justify md:text-right leading-8">
              The installation is straightforward, and our expert training
              ensures businesses can start using the software with ease.
            </p>
            <Link
              to={"#form"}
              className="bg-[#F9A21B] poppins_medium hidden md:flex ml-auto rounded-full w-fit text-white py-2 px-4 items-center gap-2"
            >
              Become a Partner
            </Link>
          </div>
        </div>
      </div>

      <div
        id="features"
        className="max-w-[1024px] mx-auto py-8 sm:py-16 text-center bg-white px-4 sm:px-8 xl:px-16"
      >
        <div className="mx-auto grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
          {[
            {
              img: "Tally Integration.svg",
              title: "Tally Integration",
              desc: "Sync sales, purchases, and stock with Tally for smooth and error-free accounting.",
            },
            {
              img: "Multiple store management.svg",
              title: "Multiple Store Management",
              desc: "Manage all store locations in one place with real-time sales and stock tracking.",
            },
            {
              img: "Accounts Report.svg",
              title: "Store-Wise Price List",
              desc: "Set custom product prices for each store based on location and business strategy.",
            },
            {
              img: "Store-Wise.svg",
              title: "Accounts Report",
              desc: "Generate profit & loss, tax, and balance reports for clear financial insights and planning.",
            },
            {
              img: "Billing.svg",
              title: "Billing",
              desc: "Generate GST-compliant bills in multiple formats and share invoices instantly via WhatsApp.",
            },
            {
              img: "Profit analysis report.svg",
              title: "Inventory",
              desc: "Track stock with serial numbers, batch details, and expiry dates for better stock management.",
            },
            {
              img: "Route plan.svg",
              title: "Profit analysis report",
              desc: "Track item-wise profits, costs, and sales to make informed business decisions.",
            },
            {
              img: "Customer Wise Price List.svg",
              title: "Route plan",
              desc: "Plan effective delivery routes for timely and cost-effective shipments.",
            },
            {
              img: "Routeplan.svg",
              title: "Customer-Wise Price List",
              desc: "Set personalized prices for each customer based on their purchase history or agreement.",
            },
          ].map((feature, index) => (
            <div key={index} className="bg-[#f1f9fc] rounded-2xl p-6 shadow-md">
              <div className="mb-6 flex justify-center">
                <img
                  src={`images/partnerIcon/${feature.img}`}
                  alt={feature.title}
                  className="w-16 h-16"
                />
              </div>
              <h5 className="text-xl poppins_semibold mb-2">{feature.title}</h5>
              <p className="text-gray-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default Partnership;
